<script setup lang="ts">
import { Button } from '@brighterly/lib-lumee-ui'

defineOptions({
  name: 'LessonRoomDevicesPermissions',
})

withDefaults(defineProps<{
  loading?: boolean
}>(), {
  loading: false,
})

const emit = defineEmits<{
  'click:allow': []
}>()

const handleAllow = (): void => emit('click:allow')
</script>

<template>
  <div class="lesson-room-devices-permissions">
    <Button
      text="Allow camera & microphone"
      :disabled="loading"
      @click="handleAllow"
    />
    <p class="lesson-room-devices-permissions__body-l-tertiary btly-text-body-l">
      If nothing happens, allow camera and microphone for this site in your browser settings.
    </p>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/LessonRoom/LessonRoomDevicesPermissions.scss" />
